/**
 * Tiny logger wrapper.
 * - In dev / preview, forwards to console.* so you still see errors in the
 *   browser console while iterating.
 * - In production, suppresses verbose levels. Errors continue to fire so
 *   real failures remain diagnosable (and can later be wired to Sentry /
 *   LogRocket without touching call sites).
 */
const isProd = process.env.NODE_ENV === 'production';

const logger = {
  debug: (...args) => { if (!isProd) console.debug(...args); },
  info:  (...args) => { if (!isProd) console.info(...args); },
  warn:  (...args) => { if (!isProd) console.warn(...args); },
  // Errors: keep them in dev, suppress in prod. Future: forward to Sentry
  // / LogRocket from here without changing call sites.
  error: (...args) => { if (!isProd) console.error(...args); },
};

export default logger;
